let info = {
  name: 'Burger Shop',
  location: [
    {
      street: '123 E 45th St',
      city: 'Kansas City',
      state: 'MO'
    }
  ],
  rating: 4.9,
  cuisine: ['American', 'Burgers']
}

export default info;